
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class AuthenticationService {
    constructor(private http: Http) { }

    login(username: string, password: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetLogin?uname=" + username + "&upass=" + password;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let abc = response.json();
                return abc.GetLoginResult;
            }));
    }

    Login(username: string, password: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getLogin";
        let orderData = { "uname": username, "upass": password };
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.set('Content-Type', 'application/json');
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    newLogin(username: string, password: string, token: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getLoginNew";
        let orderData = { "uname": username, "upass": password, "token": token };
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.set('Content-Type', 'application/json');
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(res => { return res }),
            catchError(this.handleError),);
    }

    logout(customerId: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "DeleteSession";
        let orderData = { "customerid": customerId, "stringData": sKey };
        let headers = new Headers();
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    private extractdata(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            return body.orderid || {};
        } else if (body.status == "Error") {
            return observableThrowError(body.message);
        }
    }

    private extractData(res: Response) {
        let body = res.json();
        let jsonbody = JSON.parse(body.orderid);
        return jsonbody || {};
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}